import React, { Component } from "react";
import PropTypes from "prop-types";
import Header from "./Header";
import shortid from "shortid";
import MessageBot from "./MessageBot";
import AppAlert from "./AppAlert";
import ChatWindow from "./ChatWindow";
import _ from "lodash";
import { getObjEqualIndex } from "../utils/utils";
import "./styles/App.css";

const SockJS = require("sockjs-client");
const Modal = require("boron/WaveModal");
const coreEndpoint =
  process.env.REACT_APP_CORE_SERVICE_ENDPOINT

class App extends Component {
  constructor(props) {
    super(props);
    /**
     * TODO: move all constants to a separate file
     *  move number of conversations per load to this file.
     *  It is fixed at 10 ATM.
     */

    this._HANDSHAKE = "handshake";
    this._CHAT = "chat";
    this._RECEIPT = "receipt";
    this._SOCK = new SockJS(`${coreEndpoint}/chat`);
    this.state = {
      shouldLoadMoreConversations: false,
      loadedConversationsIndex: 1,
      isHeaderOptionsDisplayed: false,
      modalUrl: "",
      userInput: "",
      isClosed: false,
      alertMessage: "",
      scrollToId: "#",
      userConversations: this._firstFewConversations() || []
    };
  }

  componentDidMount = () => {
    const self = this;
    /**
     * TODO: the event listener is triggered when a user goes from online to offline (or the reverse
     * When the user tries to get on KUDI being offline, the page is served from cache. SPA!
     * However, it keeps reloading since connection is out.
     * Detect this and DO NOT RELOAD aimlessly.
     */
    window.addEventListener("online", function () {
      self._forceReload();
    })
    window.addEventListener("offline", function () {
      self._isUserOffline = true;
      self.setState({
        isClosed: true,
        alertMessage:
          "You are offline. We will reconnect when you get back online"
      });
    })
    window.removeKudiIframeEmbed = this._removeKudiIframeEmbed

    let conversations = JSON.parse(localStorage.getItem("conversations"));
    if (conversations) {
      conversations.length > 10 &&
        this.setState({
          shouldLoadMoreConversations: true,
          scrollToId: this._getScrollId(this._firstFewConversations())
        });
    }

    this._updateScroll();
    this._SOCK.onopen = this._socketOpened;
    this._SOCK.onmessage = this._socketMessaged;
    this._SOCK.onclose = this._socketClosed;
    const REFERENCE = this._getParameterByName("ref");
    REFERENCE && this._sendReference(REFERENCE);
  };

  componentWillUnmount = () => {
    window.removeEventListener("online");
    this._SOCK.close();
    this.setState(
      {
        isClosed: true,
        alertMessage: "connecting..."
      },
      this._restoreConnection
    );
  };

  _removeKudiIframeEmbed = (node) => {
    this._hideModal(this.state.modalUrl)
  }

  _loadConversations = i => {
    const CONVERSATIONS = JSON.parse(localStorage.getItem("conversations"));
    let shouldLoadMoreConversations = CONVERSATIONS.length > 10 * i;
    let { userConversations } = this.state;
    let self = this;
    setTimeout(function () {
      self.setState(
        {
          shouldLoadMoreConversations,
          userConversations: _.takeRight(CONVERSATIONS, 10 * i)
        },
        self._scrollToId(userConversations)
      );
    }, 1000);
  };

  _firstFewConversations = () => {
    return _.takeRight(JSON.parse(localStorage.getItem("conversations")), 10);
  };

  _getScrollId = userConversations => {
    return `#${_.head(userConversations).id}`;
  };

  _scrollToId = userConversations => {
    let id = this._getScrollId(userConversations);
    let idObj = document.getElementById(id);
    let pos = this._getPosY(idObj);
    this._CHATWINDOW.scrollTop = pos;
  };

  _getPosY = obj => {
    return obj.getBoundingClientRect().top;
  };

  _forceReload = () => {
    window.location.reload(false);
  };

  _socketOpened = () => {
    console.log("OPEN: yeah socket is open");
    this.setState({
      isClosed: false,
      alertMessage: ""
    });
    const handshakeMessage = {
      type: "handshake",
      sessionId: this._getCookie("sessionId")
    };

    if (this.props.transactionType) {
      handshakeMessage.transactionType = this.props.transactionType;
    }
    this._SOCK.send(JSON.stringify(handshakeMessage));
  };

  _socketMessaged = e => {
    const message = JSON.parse(e.data);
    switch (message.type) {
      case this._HANDSHAKE:
        this._handleHandShakeMessage(message.sessionId);
        break;
      case this._CHAT:
        this._handleBotMessage(message);
        break;
      case this._RECEIPT:
        this._handleBotMessage(message);
        break;
      default:
        break;
    }
  };

  _socketClosed = () => {
    console.log("CLOSED: Yeah socket connection is closed");
    if (!this._isUserOffline) {
      function doReload() {
        var self = this;
        console.log("doing reload...");
        setTimeout(function () {
          self._forceReload();
        }, 2000);
      }
      this.setState(
        {
          isClosed: true,
          alertMessage: "Connecting..."
        },
        doReload
      );
    } else {
      this.setState({
        isClosed: true,
        alertMessage:
          "You are offline. We will reconnect when you get back online"
      });
    }
  };

  _getParameterByName = (name, url = window.location.href) => {
    name = name.replace(/[[]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  };

  _sendReference = ref => {
    var http = new XMLHttpRequest();
    var url = `${coreEndpoint}/referral/webchat/${this._getCookie(
      "sessionId"
    )}?referral_code=${ref}`;
    http.open("POST", url, true);
    console.log(url);
    http.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    http.onreadystatechange = function () {
      if (http.readyState === 4 && http.status === 200) {
        console.log(http.responseText);
      }
    };
    http.send();
  };

  _updateScroll = () => {
    if (
      this._CHATWINDOW.scrollHeight <=
      this._CHATWINDOW.getBoundingClientRect().height
    )
      return;
    this._CHATWINDOW.scrollTop =
      this._CHATWINDOW.scrollHeight -
      this._CHATWINDOW.getBoundingClientRect().height;
  };

  _getCookie = cookieName => {
    let name = cookieName + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  };

  _hideModal = reference => {
    this.refs[reference].hide();
  };

  _showModal = () => {
    this.refs[this.state.modalUrl].show();
  };

  _setModalState = url => {
    this.setState(
      {
        modalUrl: url
      },
      this._showModal
    );
  };

  _handleHandShakeMessage = sessionId => {
    this._saveCookie("sessionId", sessionId, 365);
  };

  _handleBotMessage = message => {
    let arrayOfQuickReplies = this.state.userConversations.filter(
      conversation => {
        return conversation.quickReply;
      }
    );
    if (arrayOfQuickReplies && arrayOfQuickReplies.length !== 0) {
      const index = getObjEqualIndex(
        this.state.userConversations,
        arrayOfQuickReplies[0]
      );
      this.setState(
        {
          userConversations: [
            ...this.state.userConversations.slice(0, index),
            ...[{ ...this.state.userConversations[index], quickReply: false }],
            {
              ...message,
              id: `KUDI${shortid.generate()}`,
              d: new Date().toUTCString()
            }
          ]
        },
        this._updateScrollAndStoreState
      );
    } else {
      this.setState(
        {
          userConversations: [
            ...this.state.userConversations,
            {
              ...message,
              id: `KUDI${shortid.generate()}`,
              d: new Date().toUTCString()
            }
          ]
        },
        this._updateScrollAndStoreState
      );
    }
  };

  _handleHeaderOptionsDisplayed = () => {
    this.setState((prevState, props) => {
      return {
        isHeaderOptionsDisplayed: !prevState.isHeaderOptionsDisplayed
      };
    });
  };

  _getCookie = cookieName => {
    let name = cookieName + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  };

  _saveCookie = (cookieName, cookieValue, cookieDays) => {
    let d = new Date();
    d.setTime(d.getTime() + cookieDays * 24 * 60 * 60 * 1000);
    const expires = "expires=" + d.toUTCString();
    document.cookie =
      cookieName + "=" + cookieValue + ";" + expires + ";path=/";
  };

  _deleteCookie = cookieName => {
    document.cookie = cookieName + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
  };

  _deleteUserConversation = () => {
    localStorage.removeItem("conversations");
  };

  _storeState = () => {
    localStorage.setItem(
      "conversations",
      JSON.stringify(this.state.userConversations)
    );
  };

  _updateScrollAndStoreState = () => {
    this._updateScroll();
    this._storeState();
  };

  _handleLogout = () => {
    this._deleteUserConversation();
    this._deleteCookie("sessionId");
    window.location.reload(false);
  };

  _handleChange = event => {
    this.setState({
      userInput: event.target.value
    });
  };

  _handleSendUserMessage = event => {
    event.preventDefault();
    let arrayOfQuickReplies = this.state.userConversations.filter(
      conversation => {
        return conversation.quickReply;
      }
    );
    let userResponse = {
      type: "chat",
      id: `USER${shortid.generate()}`,
      text: this.state.userInput,
      d: new Date().toUTCString()
    };
    if (arrayOfQuickReplies && arrayOfQuickReplies.length !== 0) {
      const index = getObjEqualIndex(
        this.state.userConversations,
        arrayOfQuickReplies[0]
      );
      this.setState({
        userConversations: [
          ...this.state.userConversations.slice(0, index),
          ...[{ ...this.state.userConversations[index], quickReply: false }],
          ...this.state.userConversations.slice(index + 1),
          userResponse
        ],
        userInput: ""
      });
    } else {
      this.setState(
        {
          userConversations: [...this.state.userConversations, userResponse],
          userInput: ""
        },
        this._updateScrollAndStoreState
      );
    }

    this._SOCK.send(JSON.stringify(userResponse));
  };

  _handleSendQuickReply = (reply, message) => {
    const index = getObjEqualIndex(this.state.userConversations, message);
    let userResponse = {
      type: "chat",
      id: `USER${shortid.generate()}`,
      text: reply,
      d: new Date().toUTCString()
    };
    this.setState(
      {
        userConversations: [
          ...this.state.userConversations.slice(0, index),
          ...[{ ...this.state.userConversations[index], quickReply: false }],
          ...this.state.userConversations.slice(index + 1),
          userResponse
        ]
      },
      this._updateScrollAndStoreState
    );
    this._SOCK.send(JSON.stringify(userResponse));
  };

  _handleShowQuickReply = message => {
    return (
      <ul key={shortid.generate()} className="ChatWindow--quickReply">
        {message.quickReply.map((reply, index) => {
          return (
            <li
              className="ChatWindow--quickReply--option"
              key={index}
              onClick={this._handleSendQuickReply.bind(this, reply, message)}
            >
              {reply}
            </li>
          );
        })}
      </ul>
    );
  };

  _renderModal = () => {
    const { modalUrl } = this.state;
    const contentStyle = {backgroundColor: 'transparent'}

    return (
      <Modal ref={modalUrl} contentStyle={contentStyle}>
        <div className="iframe-holder">
          <iframe
            allowTransparency="true"
            src={modalUrl}
            className="App--buttons__iframes"
          />
        </div>
        {/* <div
          onClick={this._hideModal.bind(this, modalUrl)}
          className="App--buttons__iframesBack"
        >
          Back to Chat
        </div> */}
      </Modal>
    );
  };

  render = () => {
    return (
      <section className="App">
        {this._renderModal()}
        <AppAlert
          isShown={this.state.isClosed}
          message={this.state.alertMessage}
        />
        <Header
          isHeaderOptionsDisplayed={this.state.isHeaderOptionsDisplayed}
          handleHeaderOptionsDisplayed={this._handleHeaderOptionsDisplayed}
          handleLogout={this._handleLogout}
          isSidebarDocked={this.props.isSidebarDocked}
          handleOpenSidebar={this.props.handleOpenSidebar}
        />
        <ChatWindow
          shouldLoadMoreConversations={this.state.shouldLoadMoreConversations}
          loadConversations={this._loadConversations}
          userConversations={this.state.userConversations}
          showModal={this._setModalState}
          chatWindowRef={element => {
            this._CHATWINDOW = element;
          }}
        />
        {/*render quick replies	*/}
        {this.state.userConversations.map(message => {
          return message.quickReply && this._handleShowQuickReply(message);
        })}
        <MessageBot
          placeholder="Type message here..."
          userMessage={this.state.userInput}
          handleChange={this._handleChange}
          sendUserMessage={this._handleSendUserMessage}
        />
      </section>
    );
  };
}

export default App;

App.propTypes = {
  isSidebarDocked: PropTypes.bool,
  handleOpenSidebar: PropTypes.func,
  transactionType: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/modules/App.js